import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum } from '@app/shared/common/enums';
import { Observable } from 'rxjs';
import { ApplicantRecordItem, ApplicantRecordLogItem } from '../models/applicant-record-item';

@Injectable({
  providedIn: 'root'
})
export class ApplicantRecordLogService extends HttpBaseService {

    constructor(private http: HttpClient
        , private notifyServ: NotifyService
        , private localizationService: LocalizationService
        , private configService: ConfigurationService) {
        super(http, ApiControllerEnum.HRApplicantRecordLogService, notifyServ, localizationService, configService);
      }

      SaveHRApplicantRecordLogAsync(filter: any): Observable<ApplicantRecordLogItem> {
        return this.post("SaveHRApplicantRecordLogAsync", filter, true);
      }
    }
